import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const BetDateFilter = () => {
  const classes = useStyles();
  const [betDateFilter, setSetBetDateFilter] = React.useState("today");

  const handleChange = (event) => {
    setSetBetDateFilter(event.target.value);
  };

  const options = ["today", "yesterday"];

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        value={betDateFilter}
        onChange={handleChange}
        inputProps={{
          name: "fixture date filter",
          id: "bet-date-filter",
        }}
      >
        <MenuItem aria-label="All" value="">
          <em>None</em>
        </MenuItem>
        {options.map((option, i) => (
          <MenuItem key={i} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BetDateFilter;

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: 120,
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiOutlinedInput-input": {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    "& .MuiInputBase-root": {
      color: theme.palette.common.white,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.common.white,
    },
    "& .MuiSelect-icon": {
      color: theme.palette.common.white,
    },
  },
}));
